import React from 'react';
import clsx from 'clsx';
import styles from '../FundingHistory.module.scss';

interface SummaryRowProps {
    title: string;
    amount: number;
    isPDFReport: boolean;
}

function SummaryRow({ title, amount, isPDFReport }: SummaryRowProps) {
    return (
        <div className={clsx(styles.tableRow, styles.totalsRow)}>
            <div className={styles.rowItem} style={{ gridColumn: '1 / span 2' }}>
                {title}
            </div>
            <div className={clsx(styles.rowItem, styles.alignRight)}>{amount?.toFixed(2)} Cr</div>
            <div className={styles.rowItem}></div>
            {!isPDFReport && <div className={styles.rowItem}></div>}
        </div>
    );
}

export default SummaryRow;
